import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../config/URL";

function CMSEnrollAndTermsPageEdit({ rowId, open, onClose, onSuccess }) {
  const userName = localStorage.getItem("userName");
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: "",
    },
    validationSchema: Yup.object({
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: async (values) => {
      if (!rowId) return;

      setLoading(true);
      try {
        const res = await api.put(
          `/updateDescriptionSave/${rowId}?description=${encodeURIComponent(
            values.description
          )}&updatedBy=${encodeURIComponent(userName)}`
        );

        if (res.status === 200 || res.status === 201) {
          toast.success(res.data?.message || "Updated successfully");
          onSuccess?.();
          onClose();
        } else {
          toast.error(res.data?.message || "Update failed");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  /* -------- FETCH BY ID -------- */
  const getData = async () => {
    if (!rowId) return;

    try {
      const res = await api.get(`/getByIdDescriptionSave/${rowId}`);
      formik.setValues({
        description: res.data?.description ?? "",
      });
    } catch (error) {
      toast.error("Error fetching data");
    }
  };

  useEffect(() => {
    if (open && rowId) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, rowId]);

  return (
    <Modal show={open} size="lg" onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="headColor">
          Edit Enroll And Terms
        </Modal.Title>
      </Modal.Header>

      <form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <textarea
            rows={5}
            className={`form-control ${formik.touched.description && formik.errors.description
                ? "is-invalid"
                : ""
              }`}
            {...formik.getFieldProps("description")}
            disabled={loading}
          />
          {formik.touched.description && formik.errors.description && (
            <div className="invalid-feedback">
              {formik.errors.description}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            className="btn btn-sm btn-border bg-light text-dark"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="btn btn-button btn-sm"
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2" />
            ) : null}
            Update
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default CMSEnrollAndTermsPageEdit;
